import { OperationVariables, gql } from "@apollo/client";

import GraphQL from "../graphQL";
const q = gql`
query {
    getUploadURLCompanyLogo
    {
        id
        url
        fields
    }
},
`;

/**
 * Returns the upload URL for a profile picture.
 *
 * @param callback - The callback function to handle the response data. It should accept a parameter of type
 * `{ id: string; url: string; fields: { [key: string]: string; }; }` and returns nothing.
 * @returns A promise that resolves to any value.
 */
export default function getUploadURLCompanyLogo()
{
    const variables: OperationVariables = {};
    return GraphQL.query<{ getUploadURLCompanyLogo: IUploadData }>(q, variables).then((data) =>
    {
        return data.getUploadURLCompanyLogo;
    });
}

interface IUploadData
{
    id: string,
    url: string,
    fields: {
        [key: string]: string
    }
}